module.exports = __webpack_public_path__ + "img/1_b.4dc16890.jpg";